import { BASE_DATETIME } from '@/utvStore/components/recommend/lp/commons'

import moment from 'moment'
const now = new moment()
const diffFromBase = now.diff(BASE_DATETIME, 'years')

const baseInfo = {
  id: 5,
  name: 'オッティモちゃん',
  kana: '',
  roman: 'Ottimo',
  mainMethod: '宇宙占術RPU',
  mainMethodKana: 'うちゅうせんじゅつあーるぴーゆー',
}

const additionalInfo = {
  description: `人間界をハピネスエナジーで満たすために、ぐんぐり天界からやってきた占い天使。<br>手相や西洋占星術から四柱推命、数秘術、インド占星術まであらゆる占術を使いこなし、悩める人に寄り添う占いが特長。`,
  methods: '宇宙占術ＲＰＵ（うちゅうせんじゅつあーるぴーゆー）',
  yearsOfAppraisal: `-`,
  appraisalNum: '-',
  managementOffice: {
    name: 'Luck Out',
    url: '',
  },
}

const forProfilePage = {
  realNameBornPlaceAge: '非公表',
  basicFortune: `/recommend/${baseInfo.id}/basic/input`,
  profileImage: '/static/img/recommend/lp/ottimo/profileImage1.png',
  directAppraisal: {
    message: '占い師本人による直接鑑定は、現在WEBサービスでの特典（抽選制）でのみの受付となっています。詳細は各サービスの情報をご覧ください'
  },
  digitalFortune: {
    name: '占いTV',
    url: '',
  },
  salonTypeCommunity: {
    name: 'BaseCamp（月額制／毎月抽選での有料鑑定あり）',
    url: '',
  }
}

const tellerList = {
  description: '奇抜なビジュアルながら超実力派 有名人の鑑定実績も多く悩める人に寄り添う占い天使',
  thumbnail: '/static/img/recommend/lp/ottimo/counselor_160x160.jpg',
}

export default {
  ...baseInfo,
  ...additionalInfo,
  profilePage: forProfilePage,
  tellerList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/info/profile.js